import React from "react";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";
import useOrganizationRole from "../../hooks/useOrganizationRole";
import { formatPrice } from "../../helpers/helpers";
import "./OrganizationLimitsBlock.css";

const WARNING_PERCENT = 70;
const CRITICAL_PERCENT = 90;

const formatSpace = (valueMb) => {
  if (valueMb >= 1024) {
    return `${formatPrice(Number((valueMb / 1024).toFixed(2)))} ГБ`;
  }
  return `${formatPrice(valueMb)} МБ`;
};

const LIMITS = [
  { code: "AVAILABLE_PROJECT_COUNT", label: "Проекты" },
  { code: "AVAILABLE_USER_COUNT", label: "Пользователи" },
  { code: "AVAILABLE_SPACE_MB", label: "Место на диске", isSpace: true },
];

const OrganizationLimitsBlock = () => {
  const limits = useOrganizationLimits();
  const orgRole = useOrganizationRole();

  if (!limits || !orgRole || orgRole.role !== "OWNER") return null;

  const rows = LIMITS.map(({ code, label, isSpace }) => {
    const limit = limits.find((item) => item.attributeCode === code);
    if (!limit) return null;

    const usedValue = Number(limit.usedValue);
    const used = Number.isFinite(usedValue) && usedValue > 0 ? usedValue : 0;
    const unlimited = limit.maxValue === -1;
    const maxValue = Number(limit.maxValue);
    const max = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 0;

    const percent =
      unlimited || max <= 0 ? 0 : Math.min(100, Math.round((used / max) * 100));

    return {
      key: code,
      label,
      unlimited,
      percent,
      usedText: isSpace ? formatSpace(used) : formatPrice(used),
      maxText: unlimited ? "∞" : isSpace ? formatSpace(max) : formatPrice(max),
    };
  }).filter(Boolean);

  if (!rows.length) return null;

  return (
    <div className="profile-limits">
      <div className="profile-limits-title">Лимиты рабочего пространства</div>

      {rows.map((row) => (
        <div className="profile-limits-row" key={row.key}>
          <div className="profile-limits-row-top">
            <span className="profile-limits-label">{row.label}</span>
            <span className="profile-limits-value">
              {`${row.usedText} / ${row.maxText}`}
            </span>
          </div>

          {/* {!row.unlimited && (
            <div className="profile-limits-bar">
              <div
                className={`profile-limits-fill${
                  row.percent >= CRITICAL_PERCENT
                    ? " profile-limits-fill--critical"
                    : row.percent >= WARNING_PERCENT
                      ? " profile-limits-fill--warning"
                      : ""
                }`}
                style={{ width: `${row.percent}%` }}
              />
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
};

export default OrganizationLimitsBlock;
